import React from "react";
import { Block } from "@randajan/jet-react/dom/block";

import { Locale } from "../../assets/Locale";
import { Article } from "../../elements/Article/Article";

import "./Partnerships.scss";
import { Link } from "@randajan/jet-react/dom/link";

export const Partnerships = ()=>{
    const say = Locale.use();

    return (
        <Block className="Partnerships" caption={say("navPartnerships")} level={0}>
            <Article className="slab paragraph" storeId="contentPartnership"/>
            <div className="slab">
                <Link to="/aboutUs">{say("wikiAboutLink")}</Link>
            </div>
        </Block>
    );
};
